import { createSelector, createStructuredSelector } from "reselect";
import { initialState, State as LoadingState } from "./redux";

/**
 * Direct selector to the loading state domain
 */

export const selectLoadingDomain: (any) => LoadingState = (state) =>
  state.loading || initialState;

/**
 * Custom selectors to the loading state
 */

export const selectUserInfo = createSelector(
  selectLoadingDomain,
  (substate) => substate.userInfo
);

/**
 * Multi instance selectors exporting a factory
 */
export const makeSelectLoading = () =>
  createSelector(selectLoadingDomain, (substate) => substate);

// add structured selectors here, which will be mapped as prop to scene component
export default createStructuredSelector({
  userInfo: selectUserInfo,
});
